import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { CSP_NONCE } from '@angular/core';
import { AppComponent } from './app/app.component';
import { bootstrapApplication } from '@angular/platform-browser';
import { NonceService } from './app/services/nonce.service';
import { HttpClient, HttpClientModule } from '@angular/common/http';

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));

/*const nonceService = new NonceService();

nonceService.getNonce().subscribe(
  nonceValue => {
    // Asignar el valor del nonce al CSP_NONCE
    platformBrowserDynamic([{ provide: CSP_NONCE, useValue: nonceValue }])
      .bootstrapModule(AppModule)
      .catch(err => console.error(err));
  },
  error => {
    console.error('Error al obtener el nonce:', error);
  }
);*/

/*platformBrowserDynamic([{ provide: 'nonce', useValue: nonce }])
   .bootstrapModule(AppModule)
   .catch(err => console.error(err));*/
/*bootstrapApplication(AppComponent, {
  providers: [{
    provide: CSP_NONCE,
    useValue: globalThis.myRandomNonceValue
  }]
}).catch(err => console.error(err));*/

